import ApiService from '@/core/services/api.service';

/**
 * Tìm kiếm customers (nhà cung cấp) theo searchText.
 * Dùng chung cho mọi component cần search provider.
 *
 * @param {string} searchText - Text tìm kiếm
 * @param {number} size - Số lượng kết quả (mặc định 10)
 * @returns {Promise<Array>} Danh sách customers khớp
 */
export async function searchCustomers(searchText, size = 10, activeOnly = false, extraParams = {}) {
  const trimmed = searchText?.trim() || '';
  const hasParentFilter =
    extraParams.parentId != null ||
    extraParams.parentIds != null ||
    extraParams.onlyChild === true;
  if (!trimmed && !hasParentFilter) return [];
  const params = { size, ...extraParams, customerStatus: 1 };
  if (trimmed) params.searchText = trimmed;
  //TODO review, do yêu cầu của Business chỉ lấy các trạng thái active kể cả bộ lọc,
  // nếu muốn ở bộ lọc gồm tất cả trạng thái thì uncomment đoạn code này
  // if (activeOnly) params.customerStatus = 1;
  const res = await ApiService.query('v1/customers', { params });
  return res.data?.data?.items || [];
}
